import Vue from "vue";
import Router from "vue-router";
import Axios from "../../node_modules/axios";
import { getUrlParam } from "../units/common";
import { JWT_TOKEN } from "../config/config";
Vue.use(Router);
var _import = file => {
  return () => System.import("@/views/" + file + ".vue");
};
var router = new Router({
  hashbang: true,
  saveScrollPosition: true,
  routes: [
    {
      path: "/",
      name: "index",
      component: _import("home/index"),
      meta: {
        title: "东骏正源批发商城",
        requiresAuth: true
      }
    },
    {
      path: "/personal",
      name: "personal",
      component: _import("Personal/index"),
      meta: {
        title: "个人中心",
        requiresAuth: true,
        UserCode: true
      }
    },
    {
      path: "/loading",
      name: "loading",
      component: _import("home/loading")
    },
    {
      path: "/choiceIdentity",
      name: "choiceIdentity",
      component: _import("loginSection/choiceIdentity"),
      meta: {
        title: "身份选择",
        requiresAuth: true
      }
    },
    {
      path: "/oldClients",
      name: "oldClients",
      component: _import("loginSection/oldClients"),
      meta: {
        title: "老客户登录"
      }
    },
    {
      path: "/youke",
      name: "youke",
      component: _import("loginSection/youke"),
      meta: {
        title: "用户登录"
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: _import("loginSection/login"),
      meta: {
        title: "业务员登录"
      }
    },
    {
      path: "/tourist",
      name: "tourist",
      component: _import("loginSection/tourist"),
      meta: {
        title: "游客登录"
      }
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      component: _import("loginSection/forgotPassword"),
      meta: {
        title: "忘记密码"
      }
    },
    {
      path: "/defaultShoplist",
      name: "defaultShoplist",
      component: _import("ShopCart/default"),
      meta: {
        title: "",
        requiresAuth: true,
        UserCode: true
      }
    },
    {
      path: "/shopCart",
      name: "shopCart",
      component: _import("ShopCart/index"),
      meta: {
        title: "",
        requiresAuth: true,
        UserCode: true
      }
    },
    {
      path: "/integral_list",
      name: "integral_list",
      component: _import("home/integral_list"),
      meta: {
        title: "",
      }
    },
      {
          path: "/integralNav",
          name: "integralNav",
          component: _import("home/integralNav"),
          meta: {
              title: "活动中心",
          }
      },
    {
      path:'/integral_detail',
      name:'integral_detail',
      component:_import('home/integral_detail'),
      meta: {
        title: "兑换记录",
        requiresAuth: true
      }
    },
    {
      path: "/goods_sort",
      name: "goods_sort",
      component: _import("Sort/index"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/IdxClassify",
      name: "IdxClassify",
      component: _import("Sort/IdxClassify"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/demo",
      name: "demo",
      component: _import("Sort/demo"),
      meta: {
        title: "测试用",
        requiresAuth: true
      }
    },
    {
      path: "/scan",
      name: "scan",
      component: _import("Scan/index"),
      meta: {
        title: "",
        requiresAuth: true,
        UserCode: true
      }
    },
    {
      path: "/searchIndex",
      name: "searchIndex",
      component: _import("Search/index"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/Regist",
      name: "Regist",
      component: _import("loginSection/regist"),
      meta: {
        title: "注册"
      }
    },
    {
      path: "/sortCommodities",
      name: "sortCommodities",
      component: _import("home/sortCommodities"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/productdetail",
      name: "productdetail",
      component: _import("home/productDetail"),
      meta: {
        title: ""
      }
    },
    {
      path: "/coupon",
      name: "coupon",
      component: _import("coupon/index"),
      meta: {
        title: ""
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: _import("Personal/feedBack"),
      meta: {
        title: ""
      }
    },
    {
      path: "/information",
      name: "information",
      component: _import("Personal/information"),
      meta: {
        title: ""
      }
    },
    {
      path: "/integral",
      name: "integral",
      component: _import("Personal/integral"),
      meta: {
        title: ""
      }
    },
    {
      path: "/myorder",
      name: "myorder",
      component: _import("Personal/myorder"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/mystock",
      name: "mystock",
      component: _import("Personal/mystock"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
      {
          path: "/myticket",
          name: "myticket",
          component: _import("Personal/myticket"),
          meta: {
              title: "",
              requiresAuth: true
          }
      },
    {
      path: "/my_return",
      name: "my_return",
      component: _import("Personal/myreturn"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/order_detail",
      name: "order_detail",
      component: _import("Personal/order_detail"),
      meta: {
        title: ""
      }
    },
    {
      path: "/stock_details",
      name: "stock_details",
      component: _import("Personal/details"),
      meta: {
        title: ""
      }
    },
    {
        path: "/ticket_detail",
        name: "ticket_detail",
        component: _import("Personal/ticket_detail"),
        meta: {
            title: ""
        }
    },
    {
      path: "/collection",
      name: "collection",
      component: _import("Personal/collection"),
      meta: {
        title: "",
        requiresAuth: true
      }
    },
    {
      path: "/confirmOrder",
      name: "confirmOrder",
      component: _import("order/index"),
      meta: {
        title: ""
      }
    },
    {
      path: "/confirmOrder2",
      name: "confirmOrder2",
      component: _import("order/test"),
      meta: {
        title: ""
      }
    },
    {
        path: "/newGetcoupon",
        name: "newGetcoupon",
        component: _import("coupon/Getcoupon"),
        meta: {
            title: ""
        }
    },
    {
      path: "/Getcoupon",
      name: "Getcoupon",
      component: _import("home/Getcoupon"),
      meta: {
        title: ""
      }
    },
    {
      path: "/searchlist",
      name: "searchlist",
      component: _import("Search/index"),
      meta: {
        title: ""
      }
    },
    {
      path: "/smsearch",
      name: "smsearch",
      component: _import("Search/smindex"),
      meta: {
        title: ""
      }
    },
    {
      path: "/snacks",
      name: "snacks",
      component: _import("home/snacks"),
      meta: {
        title: ""
      }
    },
    {
      path: "/hotMore",
      name: "hotMore",
      component: _import("hot/hotMore"),
      meta: {
        title: ""
      }
    },
    {
      path: "/shortage_list",
      name: "shortage_list",
      component: _import("hot/shortage_list"),
      meta: {
        title: "你要的，来货了（15天内）"
      }
    },
    {
      path: "/newProduct",
      name: "newProduct",
      component: _import("hot/newProduct"),
      meta: {
        title: ""
      }
    },
    {
      path: "/brand_shop",
      name: "brand_shop",
      component: _import("brand/index"),
      meta: {
        title: ""
      }
    },
    {
      path: "/brandlist",
      name: "brandlist",
      component: _import("brand/brandlist"),
      meta: {
        title: ""
      }
    },
    {
      path: "/specialList",
      name: "specialList",
      component: _import("home/specialList"),
      meta: {
        title: ""
      }
    },
    {
      path: "/panicBuying",
      name: "panicBuying",
      component: _import("home/panicBuying"),
      meta: {
        title: ""
      }
    },
    {
      path: "/newcomerList",
      name: "newcomerList",
      component: _import("home/newcomerList"),
      meta: {
        title: "新人专享"
      }
    },
    {
      path: "/limitDetail",
      name: "limitDetail",
      component: _import("home/limitDetail"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/comerDetail",
      name: "comerDetail",
      component: _import("home/comerDetail"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/checkIn",
      name: "checkIn",
      component: _import("home/check_in"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/error",
      name: "error",
      component: _import("error/index"),
      meta: {
        title: "扫码失败"
      }
    },
    {
      path: "/giftList",
      name: "giftList",
      component: _import("home/bigBrandlist"),
      meta: {
        title: ""
      }
    },
    {
      path: "/listdetail",
      name: "listdetail",
      component: _import("home/BrandlistDetail"),
      meta: {
        title: ""
      }
    },
    {
      path: "/formatlist",
      name: "formatlist",
      component: _import("Sort/formatlist"),
      meta: {
        title: ""
      }
    },
    {
      path: "/service_contract",
      name: "service_contract",
      component: _import("Personal/service_contract"),
      meta: {
        title: ""
      }
    },
    {
      path: "/service_detail",
      name: "service_detail",
      component: _import("Personal/service_detail"),
      meta: {
        title: ""
      }
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: _import("Personal/contact"),
      meta: {
        title: ""
      }
    },
    {
      path: "/orderReview",
      name: "orderReview",
      component: _import("Personal/orderReview"),
      meta: {
        title: ""
      }
    },
    {
      path: "/deliveryService",
      name: "deliveryService",
      component: _import("Personal/deliveryService"),
      meta: {
        title: ""
      }
    },
    {
      path: "/receivingService",
      name: "receivingService",
      component: _import("Personal/receivingService"),
      meta: {
        title: "收货说明"
      }
    },
    {
      path: "/returnService",
      name: "returnService",
      component: _import("Personal/returnService"),
      meta: {
        title: "退换货须知"
      }
    },
    {
      path: "/paymentService",
      name: "paymentService",
      component: _import("Personal/paymentService"),
      meta: {
        title: "结款支付"
      }
    },
    {
      path: "/winning_list",
      name: "winning_list",
      component: _import("home/winning_list"),
      meta: {
        title: "往期列表"
      }
    },
    {
      path: "/winning_detail",
      name: "winning_detail",
      component: _import("home/winning_detail"),
      meta: {
        title: "往期详情"
      }
    },
    {
      path: "/shop_list",
      name: "shop_list",
      component: _import("home/shop_list"),
      meta: {
        title: "中奖名单"
      }
    },
    {
      path: "/supplier",
      name: "supplier",
      component: _import("supplier/index"),
      meta: {
        title: "供应商"
      }
    },
    {
      path: "/supplier_detail",
      name: "supplier_detail",
      component: _import("supplier/detail"),
      meta: {
        title: "供应商"
      }
    },
    {
      path: "/rate",
      name: "rate",
      component: _import("Personal/rate"),
      meta: {
        title: "评价"
      }
    },
    {
      path: "/appraise",
      name: "appraise",
      component: _import("Personal/appraise"),
      meta: {
        title: "评价"
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});
router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.UserCode)) {
    if (!localStorage.getItem("cardcode") || localStorage.getItem('cardcode') == 'undefined') {
      next({
        path: "/youke",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js